var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"contained-icon-button x-link-active",class:{
    active: _vm.active
  },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"label-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_vm._t("icon",function(){return [(_vm.active)?_c('img',{attrs:{"src":_vm.activeImgSrc}}):_c('img',{attrs:{"src":_vm.imgSrc}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }